import ErrorPageTemplate from "../../components/ErrorPageTemplate";


export default function NotAuthorized () {
    return (
        <ErrorPageTemplate 
            errorImage="img/error_404.png"
            errorDescription={"Desculpe, a página que tentou acessar não existe."}
            buttonText="Voltar para página anterior"
            buttonLink="/"
        />
    )
}